module.exports = __webpack_public_path__ + "img/SAMSA.b7012fed.svg";